/**
 * The safety read of the editor and of a cut while the director works or the master is read. It
 * runs only while the realtime socket is down (`useRealtimePollInterval`).
 */
export const EDITOR_POLL_MS = 5000;
